const ENTITIES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '\'': '&#39;',
};

/**
 * Escapa texto para os pontos em que uma biblioteca de terceiros escreve com innerHTML
 * (ex.: tooltip/legenda do ApexCharts 3.23). Texto renderizado pelo React nao precisa disto.
 */
export const escapeHtml = (s: unknown): string =>
  s === null || s === undefined ? '' : String(s).replace(/[&<>"']/g, (c) => ENTITIES[c]);
